import { useEffect } from 'react';
import { SimpleStoreFragment, useStoreUpdateSubscription } from 'drycut-graphql';

type Props = {
  slug: string;
  callback?: (broadcast: SimpleStoreFragment) => void;
};

export function useStorePubSub({ slug, callback }: Props) {
  const { data } = useStoreUpdateSubscription({ variables: { slug } });
  const broadcast: SimpleStoreFragment | undefined = data?.storeUpdate;

  useEffect(() => {
    if (broadcast) {
      callback?.(broadcast);
    }
  }, [broadcast, callback]);
}
